import { monthNames } from "../constants/monthNames";
export const fetchMonthlyCostData = async (token: string, year: number, env: string) => {
  if (!token) 
    return;
    try 
    {
      const response = await fetch(`https://5286pb88cb.execute-api.us-east-2.amazonaws.com/prod/aws-monthly-costs?env=${env}&year=${year}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        },
      });

      if (!response.ok) throw new Error("Failed to fetch API data");

      const jsonResponse = await response.json();
        console.log("Raw API Response:", jsonResponse);

        if (jsonResponse?.monthly_costs) {
        // Convert monthly_costs object to array of { month, cost } format
        const formattedData = Object.entries(jsonResponse.monthly_costs as Record<string, string>).sort(([monthA], [monthB]) => Number(monthA) - Number(monthB)).map(
          ([month, cost]) => ({
            month: monthNames[parseInt(month) - 1] ?? month,
            cost: parseInt(cost),
          }));

        return formattedData;
        } 
        else 
        {
            console.error("Unexpected data format:", jsonResponse);
            return null;
        }
    }   
    catch (error) 
    {
        console.error("Error fetching API data:", error);
        return null;
    }
  };